export const updateDrawHistoryForLab = (list, newRow) => {
  return list.map((row) =>
    row.specimen_id === newRow.specimen_id ? { ...row, ...newRow } : row
  );
};

export const removeRecordForLab = (list, newRow) => {
  return list.filter((row) => row.specimen_id != newRow.specimen_id);
};
